var product_details = JSON.parse(document.getElementById('product-meta-data').textContent);

jQuery(function() {
  jQuery(".ProductForm__Inventory").remove();

  function __init_radio () {
    jQuery('.swatch :radio').change(function() {
      //console.log('yes');
      __core__action(this);
      __tooltipHandler('', false);
     
    });
  }
  
  
  function __core__action(_this) {
    if(product_details==null) return false;
    var __product_object = product_details.product.variants;
    var	__swatch_total_options = product_details.product.options.length;
    var optionIndex = jQuery(_this).parent().parent().attr('data-option-index');//jQuery(_this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(_this).val();
    var __selected__price = jQuery(_this).attr("price");
    var __variation__type = jQuery(_this).attr("variation-type");

    var __swatch_value_0 = '';
    var __swatch_value_1= '';
    var data_variant_id = '';

    //var kk = formatMoney2(2000, window.theme.moneyFormat);
    //alert(window.theme.moneyFormat);

    if(optionIndex==0){
    	__swatch_value_0 = optionValue;
        if(__swatch_total_options > 1){
            __swatch_value_1 = jQuery("input[name='option-1']:checked").val();
			
            if(optionIndex==0){
				console.log('Size Loading.....');
                swatch_load_size(__swatch_value_0, __product_object);
			}
        }
    	
    };
    if(optionIndex==1){
    	__swatch_value_1 = optionValue;
        __swatch_value_0 = jQuery("input[name='option-0']:checked").val();
    	
    };

    if(optionIndex==0 && __variation__type=='color'){
    	var _color_selected_text = jQuery("[data-option-index=0]").find('.header').attr('v-data-type');
        jQuery("[data-option-index=0]").find('.header').html(_color_selected_text + ': ' + '<b>'+__swatch_value_0+'</b>');
        _thumb_gallary_image(__swatch_value_0);
       console.log(__swatch_value_0);
    }


    
    
    if(__swatch_total_options > 1){
      //alert('+bbbbb++');
        //--double--//
        var __swatch_exist = false;
        for (i = 0; i < __product_object.length; i++) { 
            if(__product_object[i].option1==__swatch_value_0 && __product_object[i].option2==__swatch_value_1){
				__swatch_exist = true;
  				if(__product_object[i].inventory_management != null && __product_object[i].inventory_management=='shopify'){
                  //check product quantity becz shopify will manage inventory
                  if(!__product_object[i].available){
                    //alert('++A++');
                    if(__product_object[i].compare_at_price>__product_object[i].price){
                      var price_html = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">'+formatMoney2(__product_object[i].compare_at_price, window.theme.moneyFormat)+'</span>';
                      jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                    }else{
                      var price_html = '<span class="ProductMeta__Price Price Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span>';      
                      jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                    } 
                    _button_switch('S',__selected__price,__product_object[i].price);
                  } else {
                    //alert('++B++');
                    //__020
                    if(__product_object[i].compare_at_price>__product_object[i].price){
                      var price_html = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">'+formatMoney2(__product_object[i].compare_at_price, window.theme.moneyFormat)+'</span>';
                      jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                    }else{
                      var price_html = '<span class="ProductMeta__Price Price Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span>';      
                      jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                    }                    
					_button_switch('A',__selected__price,__product_object[i].price);
                  }
                } else {
                  //alert('++C++');
                  if(__product_object[i].compare_at_price>__product_object[i].price){
                      var price_html = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">'+formatMoney2(__product_object[i].compare_at_price, window.theme.moneyFormat)+'</span>';
                      jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                    }else{
                      var price_html = '<span class="ProductMeta__Price Price Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span>';      
                      jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                    } 
                  _button_switch('A',__selected__price,__product_object[i].price);
                }
  				data_variant_id = __product_object[i].id;
  				//console.log(data_variant_id);
  				break;
			}else{
              if(optionValue == __product_object[i].option1 ){
                if(__product_object[i].compare_at_price>__product_object[i].price){
                  var price_html = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">'+formatMoney2(__product_object[i].compare_at_price, window.theme.moneyFormat)+'</span>';
                  jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                }else{
                  var price_html = '<span class="ProductMeta__Price Price Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span>';      
                  jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                }
                return false;
              }
            }
        }
		if(!__swatch_exist){
            _button_switch('U','0.0000');
        }
    } else {      
    	//--single--//
      	var __swatch_exist = false;
        for (i = 0; i < __product_object.length; i++) {
          	if(__product_object[i].option1==__swatch_value_0){
              	__swatch_exist = true;
              	if(__product_object[i].inventory_management != null && __product_object[i].inventory_management=='shopify'){
                  if(!__product_object[i].available){
                       //alert('++A++');
                      if(__product_object[i].compare_at_price>__product_object[i].price){
                        var price_html = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">'+formatMoney2(__product_object[i].compare_at_price, window.theme.moneyFormat)+'</span>';
                        jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                      }else{
                        var price_html = '<span class="ProductMeta__Price Price Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span>';      
                        jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                      }
                      _button_switch('S',__selected__price,__product_object[i].price);
                  } else {
                      //alert('++B++');
                      if(__product_object[i].compare_at_price>__product_object[i].price){
                        var price_html = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">'+formatMoney2(__product_object[i].compare_at_price, window.theme.moneyFormat)+'</span>';
                        jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                      }else{
                        var price_html = '<span class="ProductMeta__Price Price Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span>';      
                        jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                      }                    
                      _button_switch('A',__selected__price,__product_object[i].price);
                  }
                } else {
                    //alert('++C+');
                      if(__product_object[i].compare_at_price>__product_object[i].price){
                        var price_html = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">'+formatMoney2(__product_object[i].compare_at_price, window.theme.moneyFormat)+'</span>';
                        jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                      }else{
                        var price_html = '<span class="ProductMeta__Price Price Text--subdued u-h4">'+formatMoney2(__product_object[i].price, window.theme.moneyFormat)+'</span>';      
                        jQuery('.features--heading-uppercase .ProductMeta__PriceList').html(price_html);
                      }
                	_button_switch('A',__selected__price,__product_object[i].price);
                }
              	data_variant_id = __product_object[i].id;
              	break;
			}
        }
    }
	if(data_variant_id != ''){	
      jQuery("#ProductSelect-product-template").val(data_variant_id);
    }
  }

	function _button_switch(button_action, _price, __raw_price) {
      if(!__vendor_JADE_Exist()){
        var _newButton = document.createElement('button');
        _newButton.setAttribute('type', 'submit');
        _newButton.className = 'ProductForm__AddToCart Button Button--full';
          if(button_action=='S'){
                jQuery(".shopify-payment-button").hide();
                _newButton.setAttribute('disabled', 'disabled');
                _newButton.classList.add('Button--secondary');
                _newButton.removeAttribute('data-action');
                _newButton.innerHTML = window.languages.productFormSoldOut;
                jQuery('.ProductForm__AddToCart').replaceWith(_newButton);
          }
          if(button_action=='U'){
                jQuery(".shopify-payment-button").hide();
                _newButton.setAttribute('disabled', 'disabled');
                _newButton.removeAttribute('data-action');
                _newButton.classList.add('Button--secondary');
                _newButton.innerHTML = window.languages.productFormUnavailable;
                jQuery('.ProductForm__AddToCart').replaceWith(_newButton);
          }
          if(button_action=='A'){
                jQuery(".shopify-payment-button").show();
                _newButton.removeAttribute('disabled');
                _newButton.classList.add('Button--secondary');
                _newButton.setAttribute('data-action', 'add-to-cart');
                _newButton.innerHTML = '\n          <span>' + window.languages.productFormAddToCart + '</span>\n          <span class="Button__SeparatorDot"></span>\n          <span data-money-convertible>' + _price + '</span>\n';
                jQuery('.ProductForm__AddToCart').replaceWith(_newButton);
          }

        if(parseInt(__raw_price) > 0){
          jQuery(".ProductMeta__Price .Price--highlight").html(_price);
          jQuery(".ProductMeta__Price").show()
        }
      } else {
        jQuery(".btn-contact-us").remove();
		jQuery(".sc-last-cart-action").after('<a class="shopify-payment-button__button--unbranded Button--full btn-contact-us" href="/pages/contact-us">Contact Us</a>');
        jQuery(".sc-last-cart-action, .sc-special-cart-button, .shopify-payment-button").hide();
      }
	}
	
	function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';

          return dollarsAmount + centsAmount;
    }
	function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
    }
	function swatch_load_size(_color_name, __product_object) {
      	var __color = [];
		jQuery(".size-filter-box").hide();
		for (i = 0; i < __product_object.length; i++) {
          	var _num_row = 0;
      		if(__product_object[i].option1 == _color_name){
				jQuery('.swatch[data-option-index="1"] [class*="S_'+__product_object[i].option2+'"]').show();
                //if(parseInt(__product_object[i].inventory_quantity) > 0){
                if(__product_object[i].available){
                  	__color.push(__product_object[i].option2);
                    jQuery('.swatch[data-option-index="1"] [class*="S_'+__product_object[i].option2+'"]').removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                } else {
                  jQuery('.swatch[data-option-index="1"] [class*="S_'+__product_object[i].option2+'"]').removeClass('available').addClass('soldout');
                }
            }
		}
    }
    function __swatch_load_action() {
		var __variation_box = jQuery(".ProductForm__Variants .swatch");
		if(__variation_box.length > 1){
          	//option 2 now do your job
			jQuery(".ProductForm__Variants .swatch input:radio:first").prop("checked", true).trigger("click");
			jQuery(".size-filter-box").hide();
			var __product_object = product_details.product.variants;
			var __swatch_value_0 = jQuery("input[name='option-0']:checked").val();
          	if(jQuery("input[name='option-0']:checked").attr("variation-type")=='color'){
          		var _color_selected_text = jQuery("[data-option-index=0]").find('.header').attr('v-data-type');
              	var _variant_name = jQuery("input[name='option-0']:checked").attr('variant-name');
              	if(_variant_name != 'undefined' && _variant_name != ''){
              		_thumb_gallary_image(_variant_name);
              	}
              	jQuery("[data-option-index=0]").find('.header').html(_color_selected_text + ': ' + '<b>'+__swatch_value_0+'</b>');
          	}
          	swatch_load_size(__swatch_value_0, __product_object);
		}
      	if(__variation_box.length > 0){
            if(jQuery("input[name='option-0']:checked").attr("variation-type")=='color'){
          		var _color_selected_text = jQuery("[data-option-index=0]").find('.header').attr('v-data-type');
              	var _variant_name = jQuery("input[name='option-0']:checked").attr('variant-name');
              	if(_variant_name != 'undefined' && _variant_name != ''){
              		_thumb_gallary_image(_variant_name);
              	}
              	jQuery("[data-option-index=0]").find('.header').html(_color_selected_text + ': ' + '<b>'+_variant_name+'</b>');
          	}
        }
	}
	_swatch_size_sorting();
	__swatch_load_action();
	unSelectSizeVariant();
	__normal_gallary_load();
	__init_radio();
	__variantSelectBasedOnUrlVariantId();
	_removeVariationTitleIfStockEmpty();

	
	function __variantSelectBasedOnUrlVariantId(){
		var __variant_Id = getUrlParameter('variant');
      	if(__variant_Id != ''){
			if(jQuery('.swatch[data-option-index="0"]').length > 0){
            	//jQuery("input[variant-id='"+__variant_Id+"']").attr('checked', true).trigger('click');
              jQuery("input[variant-id='"+__variant_Id+"']").trigger('click');
            }
		}

	}
	function unSelectSizeVariant(){
    	if(jQuery('.swatch[data-option-index="1"]').length > 0){	
    		jQuery('.size-filter-box').find(':radio').prop("checked", false);
          	if(jQuery('.swatch[data-option-index="1"]').length > 0){	
      			jQuery("#ProductSelect-product-template").val("");
    		}
   		}
    }
	/*vendor check*/
    function __vendor_JADE_Exist(){
      if(product_details.product.vendor.toLowerCase()=='jade'){
        return true;
      } else {
        return false;
      }
    }
	function __normal_gallary_load() {
      if(jQuery(".normal-gallary-collection").length > 0){
      	var __slider__html = '';
        jQuery(".normal-gallary-collection").show();
        var __thumb_gallery_images = jQuery(".Product__SlideshowNav--thumbnails a");
        
        var z= 0;
        for(i=0;i<__thumb_gallery_images.length;i++){
        	if(z==0){jQuery(__thumb_gallery_images[i]).addClass('is-selected');}
          	var __slider__image = jQuery(__thumb_gallery_images[i]).attr('slider-image-src');
          	var _image_name = jQuery(__thumb_gallery_images[i]).attr('image-name');
          	var __slider__zoom__image = jQuery(__thumb_gallery_images[i]).attr('slider-zoom-image-src');
          	if(__slider__image != 'undefined' && __slider__image != ''){
            	if(z==0){	
                	__slider__html += '<div><img image-name="'+_image_name+'" class="slider-zoom" data-zoom-image="'+__slider__zoom__image+'" src="'+__slider__image+'" /></div>';
                } else {
                  	__slider__html += '<div><img image-name="'+_image_name+'" data-zoom-image="'+__slider__zoom__image+'" src="'+__slider__image+'" /></div>';
                }
            }
          	z++;
        }
        if(__slider__html != ''){
          if(jQuery(".product-zoom-slider").length > 0){
              jQuery(".product-zoom-slider").remove();
              var __slider_parent_html = '<div class="product-zoom-slider">';
            __slider_parent_html += __slider__html;
            __slider_parent_html += '</div>';
            jQuery(".Product_Gallary_Slider_SC").html(__slider_parent_html);
            __slick__init();

          }
        }
      }
      if(jQuery(".Product__SlideshowNav--thumbnails").length==0){
      	if(jQuery(".product-zoom-slider img").length > 0) {
      		jQuery(".product-zoom-slider img").addClass('slider-zoom');
        	__slick__init();
        }
      }
	}
    
	function _thumb_gallary_image(__variant__name) { console.log(__variant__name);
      var __gallery__image__collection = new Array();
      var __slider__html = '';
      jQuery(".Product__SlideshowNav--thumbnails a").addClass('thumb-hide');
      jQuery(".Product__SlideshowNav--thumbnails a").removeClass('is-selected');
      if(jQuery(".Product__SlideshowNav--thumbnails a").length > 0){
      	var __thumb_gallery_images = jQuery(".Product__SlideshowNav--thumbnails a");
        var z= 0;
        for(i=0;i<__thumb_gallery_images.length;i++){
        	var __relation_variant_name = jQuery(__thumb_gallery_images[i]).attr('variant-relation-alt');
          	if(__relation_variant_name==__variant__name){
                var __relation_variant_name = jQuery(__thumb_gallery_images[i]).attr('variant-relation-alt');
              	var _image_name = jQuery(__thumb_gallery_images[i]).attr('image-name');
              	jQuery(__thumb_gallery_images[i]).removeClass('thumb-hide');
              	if(z==0){jQuery(__thumb_gallery_images[i]).addClass('is-selected');}
              	var __slider__image = jQuery(__thumb_gallery_images[i]).attr('slider-image-src');
              	var __slider__zoom__image = jQuery(__thumb_gallery_images[i]).attr('slider-zoom-image-src');
              	if(__slider__image != 'undefined' && __slider__image != ''){
              		__gallery__image__collection.push(__slider__image);
                  if(z==0){	
                    __slider__html += '<div><img image-name="'+_image_name+'" class="slider-zoom" data-zoom-image="'+__slider__zoom__image+'" src="'+__slider__image+'" /></div>';
                  } else {
                  	__slider__html += '<div><img image-name="'+_image_name+'" data-zoom-image="'+__slider__zoom__image+'" src="'+__slider__image+'" /></div>';
                  }
                }
              	z++;
            }
        }
        //jQuery(".Product__SlideshowNav--thumbnails a").click(function() {_change_slider_image (this);});
      }
      
      if(__slider__html != ''){
        if(jQuery(".product-zoom-slider").length > 0){
        	jQuery(".product-zoom-slider").remove();
          	var __slider_parent_html = '<div class="product-zoom-slider">';
          __slider_parent_html += __slider__html;
          __slider_parent_html += '</div>';
          jQuery(".Product_Gallary_Slider_SC").html(__slider_parent_html);
          __slick__init(); 
        }
      }
    }

	/*single product contact us*/
	if(product_details != null && product_details.product.variants[0].title=="Default Title"){
      if(__vendor_JADE_Exist()){
      	jQuery(".btn-contact-us").remove();
		jQuery(".ProductForm__AddToCart").after('<a class="shopify-payment-button__button--unbranded Button--full btn-contact-us" href="/pages/contact-us">Contact Us</a>');
        jQuery(".ProductForm__AddToCart,.shopify-payment-button").hide();
      }
    }


	/*remove variation title if all stock are empty*/
	function _removeVariationTitleIfStockEmpty(){
      var _isStock = false;
      if(product_details != null && product_details.product.variants[0].title=="Default Title"){
      	 for(i=0;i<product_details.product.variants.length;i++){
           if(product_details.product.variants[i].available){
           		_isStock = true;
             	break;
           }
         }
         if(!_isStock){
      		jQuery(".ProductForm>.swatch_options>.swatch").remove();
      	 }
      }
	}

    jQuery(".tooltip-modal-close").click(function() {__tooltipHandler('', false);});

	jQuery( ".sc-special-cart-button" ).click(function() {
  			//here we have done our custom work
      		var option1= '';
           	var option2= '';
      		var _continue = true;
      
            if(jQuery("[data-option-index=0]").length > 0){
            	option1 = jQuery("input[name='option-0']:checked").val();
            }
            if(jQuery("[data-option-index=1]").length > 0){
            	option2 = jQuery("input[name='option-1']:checked").val();
            }
      
       		if(typeof jQuery("input[name='option-1']:checked").val() == 'undefined' && option2 != ''){
              __tooltipHandler('Please Pick a Size.', true);
              _continue = false;
        	}
      
      		if(_continue){
              if(typeof option1 != 'undefined' && option1 != '' && typeof option2 != 'undefined' && option2 != ''){
                 
                if(jQuery("input[name='option-1']:checked").parent().hasClass("soldout")){
                	__tooltipHandler("Your combination isn't available. Choose from the available options to continue.", true);
                } else {
                	//add extra
                    jQuery(".OptionSelector .Popover__Content .Popover__ValueList [data-value='"+jQuery("input[name='option-0']:checked").val()+"']").trigger('click'); 
                    jQuery(".OptionSelector .Popover__Content .Popover__ValueList [data-value='"+jQuery("input[name='option-1']:checked").val()+"']").trigger('click');
                    jQuery(".sc-last-cart-action").addClass('ProductForm__AddToCart');
                    jQuery(".sc-last-cart-action").trigger("click");
                  	jQuery(".sc-last-cart-action").removeClass('ProductForm__AddToCart');
                }
              } else if(typeof option1 != 'undefined' && option1 != ''){
                    if(jQuery("input[name='option-0']:checked").parent().hasClass("soldout")){
                        __tooltipHandler("Your options isn't available. Choose from the available options to continue.", true);
                    } else {
                        jQuery(".OptionSelector .Popover__Content .Popover__ValueList [data-value='"+jQuery("input[name='option-0']:checked").val()+"']").trigger('click');
                        jQuery(".sc-last-cart-action").addClass('ProductForm__AddToCart');
                        jQuery(".sc-last-cart-action").trigger("click");
                        jQuery(".sc-last-cart-action").removeClass('ProductForm__AddToCart');
                    }
              } else {
                    jQuery(".sc-last-cart-action").addClass('ProductForm__AddToCart');
                    jQuery(".sc-last-cart-action").trigger("click");
                	jQuery(".sc-last-cart-action").removeClass('ProductForm__AddToCart');
              }
            }
	});	





    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

});

  function __slick__init() {
    if(jQuery('.product-zoom-slider').length > 0) {
      jQuery('.product-zoom-slider').slick({
          dots: false,
          infinite: false,
          autoplay: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 2000,
          adaptiveHeight: true,
          arrows: true,
       	swipe: function(slider,index){
          	__slider_thumb_select(index);
      	},
            responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }
          ]
        });
        setTimeout(function(){ jQuery('.product-zoom-slider')[0].slick.refresh(); }, 1000);
        jQuery('.product-zoom-slider').on('swipe', function(event, slick, direction) {__slider_thumb_select(slick);});
        __zoom__init();
     }
  }

  function __slider_thumb_select(_slick){
    	var __image__name = jQuery('.slick-slide[data-slick-index="'+_slick.currentSlide+'"]').find('img').attr('image-name');
    	if(__image__name != ''){
    		jQuery(".Product__SlideshowNav--thumbnails a").removeClass('is-selected');
        	jQuery('.Product__SlideshowNavImage[image-name="'+__image__name+'"]').addClass('is-selected');
      }
  }

  function __zoom__init() {
    if(jQuery('.zoomContainer').length > 0){jQuery('.zoomContainer').remove();}
    if(!detectmob()) {  	
    	jQuery('.product-zoom-slider .slider-zoom').elevateZoom({
              zoomType: "window",
              cursor: "crosshair",
              zoomWindowHeight:400,
              zoomWindowWidth:400,
        	  lensFadeIn: 300,
    		  lensFadeOut: 300,
        	  tint:true,
              tintColour:'#ccc', 
              tintOpacity:0.9
         });
    }
  }
  function _change_slider_image(obj){
    	jQuery(".Product__SlideshowNav--thumbnails a").removeClass('is-selected');
    	jQuery(obj).addClass('is-selected');
    	var __selected_image = jQuery(obj).attr('image-name');
      var __slider_elements = jQuery('.product-zoom-slider .slick-slide');
      var __current_index = jQuery('.product-zoom-slider .slick-current.slick-active').attr('data-slick-index');
      var __match_index = 0;
  	for(i=0;i<__slider_elements.length;i++){
  		var __image_src = jQuery(__slider_elements[i]).find('img').attr('image-name');
  		if(__image_src==__selected_image){
  			 __match_index = jQuery(__slider_elements[i]).attr('data-slick-index');
  			jQuery('.product-zoom-slider').slick('slickGoTo', parseInt(__match_index));
  			jQuery('.product-zoom-slider .slick-slide img').removeClass('slider-zoom');
            	jQuery('.slick-slide[data-slick-index="'+__match_index+'"]').find('img').addClass('slider-zoom');
                __zoom__init();
            	break;
  		}
  	}
  }

  function _swatch_size_sorting() {
    if(jQuery('.swatch[data-option-index="1"]').length > 0){
      var __size__elements = jQuery('.swatch[data-option-index="1"] .swatch-element');
      var __size_text_type = jQuery(__size__elements[0]).attr('data-value');
      if(__isNumber(__size_text_type)){
        	jQuery('.swatch[data-option-index="1"] .swatch-element').remove();
      	var _result = getSorted(__size__elements, 'data-value');
      	jQuery('.swatch[data-option-index="1"] .header').after(_result);
      }
    }
  }
  
  function getSorted(selector, attrName) {
      return $($(selector).toArray().sort(function(a, b){
          var aVal = parseInt(a.getAttribute(attrName)),
              bVal = parseInt(b.getAttribute(attrName));
          return aVal - bVal;
      }));
  }

  function __sorting__text($divs, attrName) {
    	var alphabeticallyOrderedDivs = $divs.sort(function (a, b) {
          return $(a).attr(attrName) > $(b).attr(attrName);
      });
      return alphabeticallyOrderedDivs;
  }
  
  function __isNumber(str) {
    if (typeof str != "string") return false // we only process strings!
    // could also coerce to string: str = ""+str
    return !isNaN(str) && !isNaN(parseFloat(str))
  }
  
  function __tooltipHandler(msg, action){
    if($(".tooltiptext").length > 0){
      if(action){
      	$(".tooltiptext").addClass('tooltip_display');
        	$(".tooltip-msg").html('<i class="fa fa-warning" aria-hidden="true" style="color:darkred;"></i> ' + msg);
        
            setTimeout(
            function() 
            {
              $(".tooltiptext").removeClass('tooltip_display');
            }, 4000);
        
      } else {
      	$(".tooltiptext").removeClass('tooltip_display');
      }
    }
  }

    function detectmob() { 
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }


/*=====================*/


function formatMoney2(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';
          

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':            
            //value = formatWithDelimiters(cents, 2);
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
     
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {     
          //return formatString.replace(placeholderRegex, value).replace('.00', '');
          return formatString.replace(placeholderRegex, value);
        }
      }  
